import React      from 'react';
import classnames from 'classnames';
import Tooltip    from './Tooltip';
import Label      from './Label';
import TextInput  from './TextInput';

const Component = props => (
  <div className={classnames('form-group', props.className)}>
    <Label label={props.label} required={props.required} /> <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
    <div className="input-group">
      <TextInput {...props} />
      <span className="input-group-text">{props.textAppend}</span>
    </div>
  </div>
);

Component.defaultProps = {
  label     : 'Text Component',
  required  : false,
  textAppend: 'in',
};

export default Component;
